import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";

interface IProps {
    title: string;
    data: number;
    color: string;
    sequence: number;
}

const SocialChart: React.FunctionComponent<IProps> = (props) => {
    const options = {
        title: "",
        pieHole: 0.65,
        colors: [props.color, "#CCCCCC"],
        pieSliceText: "none",
        enableInteractivity: false,
        pieStartAngle: 180,
        legend: {
            position: "none",
        },
        tooltip: {
            trigger: "none",
        },
        chartArea: {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
        },
    };
    const [data, setData] = useState([
        ["Social", "Value"],
        ["Score", 0],
        ["Remaining", 0],
    ]);

    useEffect(() => {
        let templateData = [
            ["Social", "Value"],
            ["Score", 0],
            ["Remaining", 0],
        ];
        templateData[1][1] = props.data;
        templateData[2][1] = 100 - props.data;
        setData(templateData);
    }, [props]);

    return (
        <React.Fragment>
            <h4 className="graph-title text-align-center" id={"chart-title-" + props.sequence}>
                {props.title}
            </h4>
            <div id="social-chart" className="reputation-chart-container">
                <Chart
                    className={"text-align-center m-chart-container"}
                    style={{ minHeight: "100px" }}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={data}
                    options={options}
                    rootProps={{ "data-testid": "1" }}
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                window.addEventListener(
                                    "keydown",
                                    (event) => {
                                        if (event.key !== "Escape") return;
                                        event.stopPropagation();
                                        window.showtoolTip();
                                    },
                                    true
                                );
                                var chart = new google.visualization.PieChart(document.getElementById("social-chart"));
                                var svg = chart.getContainer().getElementsByTagName("svg");
                                if (svg.length > 0) {
                                    svg[0].setAttribute("aria-label", "Reputation Bar Graph");
                                }
                            },
                        },
                    ]}
                />
                <div className="reputation-chart-score" aria-labelledby={"chart-title-" + props.sequence}>
                    {data[1][1]}%
                </div>
            </div>
        </React.Fragment>
    );
};
export default SocialChart;
